import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Block, Window } from '../../common/blocks';
import { BLOCK } from '../../../constants/common';
import { Button } from '../../common/buttons';
import { Text, Title } from '../../common/text';

const PageError = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    return (
        <Window>
            <Title>{t('errorOccurred')}</Title>
            <hr />
            <Text name="center">{t('pageLoadFailedDesc')}</Text>
            <Block name={BLOCK.COLUMN} style={{ marginTop: '2rem' }}>
                <Button
                    onClick={() => window.location.reload()}
                    text={t('reloadPage')}
                />
                <Button
                    className="btn btn-main"
                    onClick={() => navigate('/')}
                    text={t('mainPage')}
                />
            </Block>
        </Window>
    );
};

export default PageError;
